<form #dispatchData="ngForm" (ngModelChange)="checkFormValidity()">
  <div>
    <div class="box-body">
      <p class="centered-border1">Status Information</p>
      <div class="dispatchdatadiv">
        <div class="col-sm-3 form-group">
          <label class="font-label-text"><b>Front Office Entry:</b></label>
        </div>
        <div class="col-sm-3 form-group">
          <label class="font-label-text">Data in SAP?</label>
          <br />
          <app-radio-button class="font-label-text" [options]="isYesNo" name="dataInSap" [(ngModel)]="dataInSapValue"
            (onClick)="onDataInSapChange($event)">
          </app-radio-button>
        </div>
        <div class="col-sm-4 form-group">
          <label class="font-label-text">SAP WO#</label>
          <app-textinput [(ngModel)]="sapWoValue" name="sapWoValue" (valueChange)="onSapWoChange($event)"
          [required]="true" [placeholder]="'SAP WO#'" #sapWoValueRef="ngModel" [maxlength]="20"></app-textinput>
          @if (isWoRequired && !sapWoValue) {
            <div class="text-danger validation">
              SAP WO# is required.
            </div>
          }
        </div>
      </div>
      <hr>
        <div class="dispatchdatadiv">
          <div class="col-sm-3 form-group">
            <label class="font-label-text"><b>Analyst Entry:</b></label>
          </div>
          <div class="col-sm-8 form-group">
            <app-radio-button class="font-label-analystentry" [options]="analystEntry" name="analystEntryValue"
              [(ngModel)]="analystEntryValue" (onClick)="onAnalystEntryChange($event)">
            </app-radio-button>
          </div>
        </div>
        <hr>
          <div class="dispatchdatadiv">
            <div class="col-sm-3 form-group">
              <label class="font-label-text"><b>Dispatch Entry:</b></label>
            </div>
            <div class="col-sm-8 form-group">
              <app-radio-button class="font-label-text" id="dispatchEntry" [isDisabled]="disabledispatchEntry"
                [options]="dispatchEntry" name="dispatchEntryValue" [(ngModel)]="dispatchEntryValue"
                (onClick)="onDispatchEntryChange($event)">
              </app-radio-button>
            </div>
          </div>
          <hr>
            <div>
              <div class="dispatchdatadiv">
                <div class="col-sm-3 form-group">
                  <label class="font-label-text"><b>Service Tech:</b></label>
                </div>
                <div class="col-sm-3 form-group">
                  <label class="font-label-text">First Name:</label>
                  <app-textinput [(ngModel)]="dispatchFirstNameValue" name="dispatchFirstNameValue"
                    (valueChange)="onDispatchFirstNameChange($event)" [placeholder]="'First Name'" [customClass]="'w-[170px]'"
                  #dispatchFirstNameValueRef="ngModel" [maxlength]="15"></app-textinput>
                  @if (isServiceTechRequired && !dispatchFirstNameValue) {
                    <div class="text-danger validation">
                      First Name is required.
                    </div>
                  }
                </div>
                <div class="col-sm-3 form-group">
                  <label class="font-label-text">Last Name:</label>
                  <app-textinput [(ngModel)]="dispatchLastNameValue" name="dispatchLastNameValue" [customClass]="'w-[170px]'"
                    (valueChange)="onDispatchLastNameChange($event)" [placeholder]="'Last Name'"
                  #dispatchLastNameValueRef="ngModel" [maxlength]="20"></app-textinput>
                  @if (isServiceTechRequired && !dispatchLastNameValue) {
                    <div class="text-danger validation">
                      Last Name is required.
                    </div>
                  }
                </div>
                <div class="col-sm-3 form-group">
                  <label class="font-label-text">Tech ID:</label>
                  <app-textinput [(ngModel)]="dispatchTechIdValue" name="dispatchTechIdValue" [customClass]="'w-[170px]'"
                    (valueChange)="onDispatchTechIdChange($event)" [required]="true" [maxlength]="10"
                  [placeholder]="'Tech ID'" #dispatchTechIdValueRef="ngModel"></app-textinput>
                </div>
              </div>
            </div>
            <hr>
              <div class="dispatchdatadiv">
                <div class="col-sm-12 form-group">
                  <label class="font-label-text"><b>Status Update Notes:</b></label>
                </div>
              </div>
              <div class="dispatchdatadiv">
                <div class="col-sm-12 form-group">
                  <app-text-area placeholder="Status Update Notes" name="statusUpdateNotesValue"
                    [(ngModel)]="statusUpdateNotesValue" [customErrorMessage]="'Please provide Status Update Notes.'"
                    (change)="onStatusUpdateNotesChange($event)" [cols]="81">
                  </app-text-area>
                </div>
              </div>
            </div>
            @if (isEdit) {
              <div>
                <p class="centered-border1">History Log</p>
                @if (isHistoryLogs) {
                  <app-table #tblConfig [showCheckRowColumn]="false" [SingleRowSelection]="true"
                    [columns]="historyLogsColumns" [rows$]="historyLogs$" [pageSize]="10" [totalRecords]="totalRecords"
                    (onAction2ButtonClicked)="onReloadClicked()" [actionButtons]="actionButtons"
                    (sortClicked)="onSortClicked($event)" (onSearchText)="onSearchText($event)"
                  (pageChanged)="onPageChanged($event)" (onCellClicked)="onCellClicked($event)"></app-table>
                }
              </div>
            }
          </div>
        </form>